import React from 'react';
import EventHeader from '@features/eventDetail/components/EventHeader';
import EventDescription from '@features/eventDetail/components/EventDescription';
import EventContentWithSidePanel from '@features/eventDetail/components/EventContentWithSidePanel';

const EventDescriptionTemplate = () => (
  <>
    <EventHeader />
    <EventContentWithSidePanel>
      <EventDescription />
    </EventContentWithSidePanel>
  </>
);

export default EventDescriptionTemplate;
